var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2387_10940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0.250004H8.0625L7.84219 -0.188277C7.79552 -0.281977 7.72363 -0.360795 7.63461 -0.415865C7.54558 -0.470935 7.44296 -0.500071 7.33828 -0.499996H4.65938C4.55493 -0.500397 4.45249 -0.47137 4.36378 -0.416239C4.27508 -0.361108 4.20369 -0.282103 4.15781 -0.188277L3.9375 0.250004H1.125C1.02554 0.250004 0.930161 0.289513 0.859835 0.359839C0.789509 0.430165 0.75 0.525548 0.75 0.625004L0.75 1.375C0.75 1.47446 0.789509 1.56984 0.859835 1.64017C0.930161 1.7105 1.02554 1.75 1.125 1.75H10.875C10.9745 1.75 11.0698 1.7105 11.1402 1.64017C11.2105 1.56984 11.25 1.47446 11.25 1.375V0.625004C11.25 0.525548 11.2105 0.430165 11.1402 0.359839C11.0698 0.289513 10.9745 0.250004 10.875 0.250004ZM1.99688 10.4453C2.01476 10.7309 2.14082 10.999 2.34939 11.1949C2.55796 11.3909 2.83336 11.5 3.11953 11.5H8.88047C9.16664 11.5 9.44204 11.3909 9.65061 11.1949C9.85918 10.999 9.98524 10.7309 10.0031 10.4453L10.5 2.5H1.5L1.99688 10.4453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2387_10940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.162340ec53cbc8e8c03bf3364308045e.svg";
export { ForwardRef as ReactComponent };